import { TOOL_CATEGORIES } from '../../modules/tools';

const CATEGORY_LABELS = new Map(TOOL_CATEGORIES.map((category) => [category.id, category.label]));

const Sidebar = ({
  tools,
  allTools,
  groupedTools,
  favorites,
  onToggleFavorite,
  selectedToolId,
  onSelectTool,
  expandedCategories,
  onToggleCategory,
}) => {
  const sourceForFavorites = allTools ?? tools;
  const favoriteTools = favorites
    .map((favoriteId) => sourceForFavorites.find((tool) => tool.id === favoriteId))
    .filter(Boolean);

  const renderToolButton = (tool) => {
    const isSelected = selectedToolId === tool.id;
    const isFavorite = favorites.includes(tool.id);

    return (
      <div key={tool.id} className="group flex items-center justify-between gap-2">
        <button
          type="button"
          onClick={() => onSelectTool(tool.id)}
          className={`flex-1 rounded-lg border px-3 py-2 text-left text-sm transition ${
            isSelected
              ? 'border-brand-primary bg-brand-primary/10 text-brand-primary dark:border-brand-primary/60 dark:bg-brand-primary/20'
              : 'border-transparent text-slate-600 hover:border-slate-300 hover:bg-slate-100 dark:text-slate-300 dark:hover:border-slate-600 dark:hover:bg-slate-800'
          }`}
        >
          <span className="block font-medium">{tool.name}</span>
          <span className="text-xs text-slate-500 dark:text-slate-400">
            {tool.description}
          </span>
        </button>

        <button
          type="button"
          onClick={() => onToggleFavorite(tool.id)}
          className={`rounded-md border px-2 py-1 text-xs transition ${
            isFavorite
              ? 'border-amber-500 bg-amber-100 text-amber-700 dark:border-amber-400 dark:bg-amber-500/20 dark:text-amber-300'
              : 'border-slate-200 text-slate-400 hover:border-slate-300 hover:text-slate-600 dark:border-slate-700 dark:text-slate-500 dark:hover:text-slate-300'
          }`}
          aria-label={isFavorite ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
        >
          {isFavorite ? '★' : '☆'}
        </button>
      </div>
    );
  };

  return (
    <aside className="h-full w-full max-w-xs flex-shrink-0 overflow-y-auto border-r border-slate-200 bg-white px-4 py-6 dark:border-slate-800 dark:bg-slate-900 lg:max-w-sm">
      <div className="space-y-6">
        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-400">
            Favoritos
          </h2>
          <div className="mt-3 space-y-2">
            {favoriteTools.length > 0 ? (
              favoriteTools.map((tool) => renderToolButton(tool))
            ) : (
              <p className="text-sm text-slate-400">Acesse aqui suas ferramentas favoritas.</p>
            )}
          </div>
        </div>

        <div>
          <h2 className="text-sm font-semibold uppercase tracking-wide text-slate-400">
            Todas as ferramentas
          </h2>
          <div className="mt-3 space-y-4">
            {TOOL_CATEGORIES.map((category) => {
              const categoryTools = groupedTools[category.id] ?? [];
              if (categoryTools.length === 0) {
                return null;
              }

              const isExpanded = expandedCategories.has(category.id);
              return (
                <div key={category.id} className="rounded-lg border border-slate-200 dark:border-slate-800">
                  <button
                    type="button"
                    className="flex w-full items-center justify-between bg-slate-50 px-3 py-2 text-left text-sm font-semibold text-slate-600 transition hover:bg-slate-100 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
                    onClick={() => onToggleCategory(category.id)}
                    aria-expanded={isExpanded}
                  >
                    <span>{CATEGORY_LABELS.get(category.id) ?? category.id}</span>
                    <span className="text-xs text-slate-500">
                      {isExpanded ? 'Recolher' : 'Expandir'}
                    </span>
                  </button>

                  {isExpanded && (
                    <div className="space-y-2 px-3 py-2">
                      {categoryTools.map((tool) => renderToolButton(tool))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
